import React, { useState } from 'react';
import Footer from './Footer';

export default function FeedbackPage() {
  // State to manage form inputs
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [feedbackType, setFeedbackType] = useState('general');
  const [satisfaction, setSatisfaction] = useState('3'); // Default to Neutral
  const [comments, setComments] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can handle form submission logic here
    console.log({
      name,
      email,
      feedbackType,
      satisfaction,
      comments,
    });
    alert('Thank you for your feedback!');
  };

  return (
    <div className="flex h-full flex-col bg-background">
      <main className="flex-1 mb-10">
        <div className="container mx-auto flex items-center justify-center p-4">
          <div className="w-full max-w-4xl">
            <div>
              <h1 className="text-5xl md:text-8xl font-bold pb-10">Feedback</h1>
            </div>
            <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col space-y-1.5 p-6">
                  <h3 className="text-2xl font-semibold leading-none tracking-tight">Submit Your Feedback</h3>
                  <p className="text-sm text-muted-foreground">
                    We value your input. Please share your thoughts with us.
                  </p>
                </div>
                <div className="space-y-6 p-6">
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div className="space-y-2">
                      <label htmlFor="name" className="text-sm font-medium leading-none">
                        Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter your name"
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="email" className="text-sm font-medium leading-none">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                      />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="feedback-type" className="text-sm font-medium leading-none">
                      Feedback Type
                    </label>
                    <select
                      id="feedback-type"
                      value={feedbackType}
                      onChange={(e) => setFeedbackType(e.target.value)}
                      className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                      <option value="general">General Feedback</option>
                      <option value="bug">Bug Report</option>
                      <option value="feature">Feature Request</option>
                      <option value="improvement">Improvement Suggestion</option>
                    </select>
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-medium leading-none">How satisfied are you?</label>
                    <div className="flex items-center space-x-2 pt-2 sm:space-x-4">
                      {[
                        { value: '1', label: 'Very Dissatisfied' },
                        { value: '2', label: 'Dissatisfied' },
                        { value: '3', label: 'Neutral' },
                        { value: '4', label: 'Satisfied' },
                        { value: '5', label: 'Very Satisfied' },
                      ].map((item) => (
                        <label key={item.value} htmlFor={`satisfaction-${item.value}`} className="cursor-pointer">
                          <input
                            type="radio"
                            id={`satisfaction-${item.value}`}
                            name="satisfaction"
                            value={item.value}
                            checked={satisfaction === item.value}
                            onChange={(e) => setSatisfaction(e.target.value)}
                            className="peer sr-only"
                          />
                          <SatisfactionIcon rating={item.value} />
                          <span className="sr-only">{item.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="comments" className="text-sm font-medium leading-none">
                      Comments
                    </label>
                    <textarea
                      id="comments"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                      placeholder="Please provide more details."
                      rows="5"
                      className="min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                    />
                  </div>
                </div>
                <div className="flex items-center p-6">
                  <button
                    type="submit"
                    className="inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                    Submit Feedback
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

// Helper component for satisfaction icons to keep the main component clean
const SatisfactionIcon = ({ rating }) => {
  const iconProps = {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className: 'h-8 w-8 text-muted-foreground peer-checked:text-primary',
  };

  switch (rating) {
    case '1':
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M8 15h8"></path>
          <path d="M9 9h.01"></path>
          <path d="M15 9h.01"></path>
        </svg>
      );
    case '2':
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m8 15 4-4 4 4"></path>
          <path d="M9 9h.01"></path>
          <path d="M15 9h.01"></path>
        </svg>
      );
    case '3':
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M8 12h8"></path>
        </svg>
      );
    case '4':
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m8 14 1.5-2.5L12 10l2.5 1.5L16 14"></path>
          <path d="M9 9h.01"></path>
          <path d="M15 9h.01"></path>
        </svg>
      );
    case '5':
      return (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M8 14s1.5-2 4-2 4 2 4 2"></path>
          <path d="M9 9h.01"></path>
          <path d="M15 9h.01"></path>
        </svg>
      );
    default:
      return null;
  }
};
